/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('PaymentView', ["$timeout","GiftItemData","CheckDepositData",function ($timeout,GiftItemData,CheckDepositData){

        var  PaymentView = function (payment,saleView)
        {
            this.type=null; //check enum in ConstantsSalePaymentType.js
            this.price = null;
            this.date = null;
            this.check = false;
            this.datePickerOpened = false;
            this.giftItemView=null;
            this.canChange = true;
            this.canDelete = true;
            this.saleView = saleView;
            this.cdIndex =-1; //checkDeposit index
            this.otherPaymentTypeView = null;
            if (payment!==undefined && payment!=null)
            {
                this.type =  payment.type;
                this.price = payment.price;
                this.check = payment.check;

                this.date = typeof payment.date === "number" ? new Date(payment.date) : payment.date;
                if (this.date) {
                    var currentTime = new Date();
                    this.date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                }

                if (payment.otherPaymentType && this.saleView && this.saleView.posView)
                    this.otherPaymentTypeView = this.saleView.posView.domainView.getOtherPaymentTypeView(payment.otherPaymentType);
                if (this.saleView) {
                    this.canChange = this.saleView.status == "created" || this.saleView.status == "waiting" || (this.type != "CBONLINE");
                    this.canDelete = this.saleView.status == "created" || this.saleView.status == "waiting" || ((this.saleView.status == "sold" || this.saleView.status == "advance") && this.canChange && this.type != "GIFT");
                }
                if (payment.checkDeposit)
                    this.cdIndex =  CheckDepositData.getIndexOf(payment.checkDeposit);
            }

        }
        PaymentView.prototype.getClone = function (saleView)
        {
            var paymentView = new PaymentView(saleView);
            paymentView.type = this.type;
            paymentView.price = this.price;
            paymentView.date = this.date;
            paymentView.giftItemView = this.giftItemView;
            paymentView.otherPaymentTypeView = this.otherPaymentTypeView;
            paymentView.cdIndex = this.cdIndex;
            return paymentView;
        };
        PaymentView.prototype.init = function (type,price,date,otherPaymentTypeView)
        {
            this.type=type;
            this.price=price;

            if (date !==undefined && date)
                this.date = date;
            else
            if (this.saleView && this.saleView.dayView)
            {
                this.date  = new Date(this.saleView.dayView.date);
                var currentTime = new Date();
                this.date.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

                var today = new Date();
                if (today.getTime() < this.date.getTime())//use ticket date only if the ticket date is in the past.
                    this.date = today;
            }
            else
            {
                this.date  = new Date();
            }
            this.otherPaymentTypeView = otherPaymentTypeView;
            this.canChange = this.type!="CBONLINE";
            this.canDelete = this.canChange;
        };
        PaymentView.prototype.copyDataTo = function(payment)
        {
            payment.type = this.type;
            payment.price = this.price;
            payment.date = this.date;
            payment.check = this.check;;
            if (this.giftItemView)
                payment.giftItem = GiftItemData.getByIndex(this.giftItemView.giIndex);
            else
                payment.giftItem = null;
            if (this.otherPaymentTypeView)
                payment.otherPaymentType = this.otherPaymentTypeView.getModel();
            else
                payment.otherPaymentType = null;
            payment.checkDeposit = CheckDepositData.getByIndex(this.cdIndex);;
            return payment;
        };
        PaymentView.prototype.displayStartDatePickerF = function (open)
        {
            if (open)
            {
                var payment = this;
                $timeout(function () {
                    payment.datePickerOpened = true;
                });

            }
        }
        return  PaymentView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/PaymentView.js